var _path, _path2, _g, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForbidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 183,
    viewBox: "0 0 151 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 183C116.921 183 150.5 149.421 150.5 108C150.5 66.5786 116.921 33 75.5 33C34.0786 33 0.5 66.5786 0.5 108C0.5 149.421 34.0786 183 75.5 183Z",
    fill: "url(#paint0_linear_2_1175)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_1175",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 33,
    width: 151,
    height: 150
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 183C116.921 183 150.5 149.421 150.5 108C150.5 66.5786 116.921 33 75.5 33C34.0786 33 0.5 66.5786 0.5 108C0.5 149.421 34.0786 183 75.5 183Z",
    fill: "url(#paint1_linear_2_1175)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_1175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.9222 201.199C84.5922 195.432 79.5266 182.68 79.2785 170.366C79.2422 168.564 77.7462 167.088 75.9485 167.216L75.5398 167.245C74.0284 167.352 72.8247 168.57 72.8247 170.085C72.8242 183.717 78.1969 199.072 92.1901 206.194C95.1019 207.676 98.4039 208.925 101.984 209.918C103.408 210.313 104.879 209.528 105.407 208.147C106.042 206.484 105.069 204.648 103.364 204.133C100.641 203.311 98.1375 202.326 95.9222 201.199Z",
    fill: "#1485FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5 126.604C48.5 125.166 49.6657 124 51.1038 124H99.8962C101.334 124 102.5 125.166 102.5 126.604V143C102.5 157.912 90.4117 170 75.5 170C60.5883 170 48.5 157.912 48.5 143V126.604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 106C57.5 103.791 59.2909 102 61.5 102C63.7091 102 65.5 103.791 65.5 106V124H57.5V106Z",
    fill: "#1485FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5 106C85.5 103.791 87.2909 102 89.5 102C91.7091 102 93.5 103.791 93.5 106V124H85.5V106Z",
    fill: "#1485FD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 133C61.1716 133 60.5 133.672 60.5 134.5C60.5 135.328 61.1716 136 62 136H89C89.8284 136 90.5 135.328 90.5 134.5C90.5 133.672 89.8284 133 89 133H62ZM65 139C64.1716 139 63.5 139.672 63.5 140.5C63.5 141.328 64.1716 142 65 142H86C86.8284 142 87.5 141.328 87.5 140.5C87.5 139.672 86.8284 139 86 139H65ZM67.5 146.5C67.5 145.672 68.1716 145 69 145H83C83.8284 145 84.5 145.672 84.5 146.5C84.5 147.328 83.8284 148 83 148H69C68.1716 148 67.5 147.328 67.5 146.5ZM75.5 159C76.6046 159 77.5 158.105 77.5 157C77.5 155.895 76.6046 155 75.5 155C74.3954 155 73.5 155.895 73.5 157C73.5 158.105 74.3954 159 75.5 159Z",
    fill: "#B4DAFF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1665 16.0522C66.4149 21.8197 71.4431 34.5756 71.6878 46.8908C71.7236 48.6914 73.2101 50.1625 75.0006 50.0345L75.3739 50.0079C76.8871 49.8997 78.0944 48.6734 78.094 47.1514C78.0907 33.5232 72.7564 18.1764 58.8712 11.0568C55.9853 9.57714 52.7135 8.32984 49.1666 7.33792C47.7447 6.94029 46.2726 7.73086 45.7463 9.11828C45.1172 10.7768 46.0791 12.6009 47.7676 13.114C50.4757 13.937 52.9644 14.923 55.1665 16.0522Z",
    fill: "#1485FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 87.6473C102.5 89.0853 101.334 90.251 99.8962 90.251L51.5012 90.251C50.0632 90.251 48.8974 89.0853 48.8974 87.6473L48.8974 71.0523C48.8974 56.2504 60.8968 44.251 75.6987 44.251C90.5007 44.251 102.5 56.2504 102.5 71.0523L102.5 87.6473Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.828 84.251C89.6565 84.251 90.328 83.5795 90.328 82.751C90.328 81.9226 89.6565 81.251 88.828 81.251L62.0488 81.251C61.2204 81.251 60.5488 81.9226 60.5488 82.751C60.5488 83.5795 61.2204 84.251 62.0488 84.251L88.828 84.251ZM88.828 72.251C89.6565 72.251 90.328 71.5795 90.328 70.751C90.328 69.9226 89.6565 69.251 88.828 69.251L62.0488 69.251C61.2204 69.251 60.5488 69.9226 60.5488 70.751C60.5488 71.5795 61.2204 72.251 62.0488 72.251L88.828 72.251ZM83.3796 76.751C83.3796 77.5795 82.708 78.251 81.8796 78.251L68.0047 78.251C67.1763 78.251 66.5047 77.5795 66.5047 76.751C66.5047 75.9226 67.1762 75.251 68.0047 75.251L81.8796 75.251C82.708 75.251 83.3796 75.9226 83.3796 76.751ZM75.5221 51.251C73.8774 51.251 72.5441 52.5942 72.5441 54.251C72.5441 55.9079 73.8774 57.251 75.5221 57.251C77.1667 57.251 78.5 55.9079 78.5 54.251C78.5 52.5942 77.1667 51.251 75.5221 51.251Z",
    fill: "#B4DAFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1175",
    x1: 75.5,
    y1: 33,
    x2: 75.5,
    y2: 183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_1175",
    x1: 75.5,
    y1: 33,
    x2: 75.5,
    y2: 183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbidden);
export default __webpack_public_path__ + "static/media/forbidden.f663684464ce136082fdd72e9ed7cc92.svg";
export { ForwardRef as ReactComponent };